/**
 * Get the Cloudflare Turnstile site key for the current environment
 *
 * This value is injected by webpack DefinePlugin at build time.
 * process.env.TURNSTILE_SITE_KEY is replaced directly by DefinePlugin.
 *
 * @returns {string} The Turnstile site key
 */
export const getTurnstileSiteKey = () => {
    // @ts-ignore - process.env.TURNSTILE_SITE_KEY is replaced at build time by webpack DefinePlugin
    return process.env.TURNSTILE_SITE_KEY || '0x4AAAAAACbJFnDlVOJsr0XS';
};
